export const apiUrl = "https://konnectfbr.com/api";
//export const apiUrl = "http://localhost:3060";

